<div class="input-group">
    <span class="input-group-addon">File Name Filter</span>
    <input type="text" class="form-control" [(ngModel)]="filename"/>
    <div class="input-group-btn">
        <button type="button" class="btn btn-primary" (click)="clear()">
            Clear
        </button>
        <button type="button" class="btn btn-primary" (click)="search()">
            Search
        </button>
    </div>
</div>